import { kebabCase } from 'es-toolkit';

export type TextStyleMixin = {
  fontSize?: number;
  fontWeight?: number | 'normal' | 'bold';
  fontStyle?: 'normal' | 'italic';
  textTransform?: 'capitalize' | 'lowercase' | 'uppercase';
  textAlign?: 'left' | 'center' | 'right';
};

export const textStyleMixin = ({
  _textStyle
}: {
  _textStyle?: TextStyleMixin;
}) => {
  return (
    _textStyle &&
    Object.entries(_textStyle).reduce(
      (acc, [key, value]) =>
        acc +
        `${kebabCase(key)}: ${value}${typeof value === 'number' ? 'px' : ''};`,
      ''
    )
  );
};
